import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/leaflet'
import './plugins/locale'
import InputFacade from 'vue-input-facade'
import Fragment from 'vue-fragment'
import './plugins/apexchart';

Vue.config.productionTip = false
Vue.use(InputFacade)
Vue.use(Fragment.Plugin)

export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
